"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const asText = (richTextField, separator = " ") => {
  let result = "";
  for (let i = 0; i < richTextField.length; i++) {
    if ("text" in richTextField[i]) {
      result += (result ? separator : "") + richTextField[i].text;
    }
  }
  return result;
};
exports.asText = asText;
//# sourceMappingURL=asText.cjs.map
